<div class="icon-mi-left">
    <a href="{{link}}"><img [src]="leadingImage" alt="" class="img-fluid" height="60" width="60" loading="lazy"></a>
    <a href="{{link}}"><div class="icon-mi-left-content">
        <h2 class="h4">{{title}}</h2>
        <p>{{content}}</p>
    </div></a>
</div>